<script setup lang="ts">
import type { IMarketIndex } from '@types'
import MarketsAdapter from '@adapters/MarketsAdapter'

const indices = ref<Array<IMarketIndex> | null>(null)
const scrollContainer = ref<HTMLElement>()

onMounted(async () => {
  indices.value = await MarketsAdapter.getIndices()
})
</script>

<template>
  <div class="indices-container">
    <div ref="scrollContainer" class="indices-scroll-wrapper">
      <div class="indices-scroll-content -ml-[12px]">
        <MarketIndexItem
          v-for="index in indices"
          :key="index.id"
          :index="index"
          class="index-item"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.indices-container {
  width: 100%;
  position: relative;
}

.indices-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.indices-scroll-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.indices-scroll-content {
  display: flex;
  gap: 16px; /* Adjust spacing between cards */
  padding: 16px; /* Add padding for better edge spacing */
  min-width: min-content; /* Ensure content doesn't wrap */
}

.index-item {
  flex: 0 0 auto; /* Prevent items from shrinking */
  min-width: 280px; /* Set minimum width for each card */
  /* Adjust based on your MarketIndexItem component's ideal width */
}

/* Optional: Add scroll indicators or gradients */
.indices-container::before,
.indices-container::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20px;
  pointer-events: none;
  z-index: 1;
}

.indices-container::before {
  left: 0;
  background: linear-gradient(to right, rgba(0,0,0,0.8), transparent);
}

.indices-container::after {
  right: 0;
  background: linear-gradient(to left, rgba(0,0,0,0.8), transparent);
}

/* Add subtle shadow for depth on mobile */
@media (max-width: 768px) {
  .indices-scroll-content {
    padding: 12px;
    gap: 12px;
  }

  .index-item {
    min-width: 180px; /* Slightly smaller on mobile */
  }
}
</style>
